export default function dayInRange(Utils, dateFilter) {
  'ngInject';

  return {
    require: '^ngModel',
    link($scope, $element, $attrs, ngModel) {
      const options = $scope.$eval($attrs.dayInPayrollPeriod);
      if (!options.payrollRangePicker) {
        return;
      }

      $scope.$watch(
        () =>
          JSON.stringify({
            date: $scope.dt.date,
            model: ngModel.$viewValue,
          }),
        () => {
          const { date } = $scope.dt;
          const model = ngModel.$viewValue;
          const periodDays = Utils.getDaysForPeriod('payroll', model);
          toggleClasses(
            'day-in-range',
            Utils.getRealDate(periodDays[0]),
            Utils.getRealDate(periodDays[periodDays.length - 1]),
            date
          );
        }
      );

      function toggleClasses(className, from, to, date) {
        _toggleClass(from <= date && date <= to, className);
        _toggleClass(toDate(from) === toDate(date), `${className}-first`);
        _toggleClass(toDate(to) === toDate(date), `${className}-last`);
      }

      function _toggleClass(condition, className) {
        if (condition) {
          $element.addClass(className);
        } else {
          $element.removeClass(className);
        }
      }
    },
  };

  function toDate(date) {
    return dateFilter(date, 'yyyy-MM-dd');
  }
}
